import BaseLogic from "../base_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import vuexStore from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"
import {
  TischMitFiliale,
  IdRequest,
  RemoteResult,
  BestellungPending,
  Terminart,
  BestellungFilialeRequest,
  BestellungList,
  Bestellung,
  BPBeginnenSofortRequest,
} from "mangdto"

export default class TischbestellungStartenLogic extends BaseLogic {
  tisch: TischMitFiliale
  aktuelleBestellungen: Bestellung[] = []

  init(tischId: string) {
    var request = new IdRequest()
    request.id = tischId

    Poster.postUser<RemoteResult<TischMitFiliale>>(
      RestPaths.filialeDetailsMitTisch,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.tisch = response.data.payload
      }
    })

    var bestellungRequest = new BestellungFilialeRequest()
    bestellungRequest.identifierId = vuexStore.state.user.identifier
    bestellungRequest.filialeId = this.mainLogic.filiale.filialeId

    Poster.postUser<RemoteResult<BestellungList>>(
      RestPaths.bestellungKundeFilialeAktuell,
      bestellungRequest,
    ).then((response) => {
      if (response.data.success) {
        this.aktuelleBestellungen = response.data.payload.list
      }
    })
  }

  bestellungStarten() {
    var request = new BPBeginnenSofortRequest()
    request.tischId = this.tisch.tisch.id
    request.personen = 2
    request.identifier = vuexStore.state.user.identifier

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnenSofort,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.Sofortbestellung
        this.mainLogic.bestellungPending.sofort.tischId = this.tisch.tisch.id
        this.mainLogic.bestellungPending.sofort.tischBezeichnung =
          this.tisch.tisch.tischnummer
        this.mainLogic.neueBestellung = true

        router.push({
          name: RouteNames.NEU.SOFORTBESTELLUNG_BESTELLART,
        })
      }
    })
  }

  bestellungAnzeigen(bestellung: Bestellung) {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { bestellungId: bestellung.id },
    })
  }
}
